import { createAction, createAsyncAction } from "typesafe-actions";

import * as T from "./types";

export const updateSetup = createAction("UPDATE_SETUP")<Partial<T.Setup>>();

export const updateStrategy = createAction("UPDATE_STRATEGY_SETUP")<Partial<T.Strategy>>();
export const updateModel = createAction("UPDATE_MODEL_SETUP")<Partial<T.ModelSetup>>();

export const loadSnapshots = createAction("LOAD_BACKTEST_SNAPSHOT")<{ setup: T.Setup; result?: T.Result }>();

export const fetchTickers = createAsyncAction("FETCH_TICKER_REQUEST", "FETCH_TICKER_SUCCESS", "FETCH_TICKER_FAILURE")<
  { region: string; text: string },
  T.Tickers[],
  void
>();

export const fetchBacktestMeta = createAsyncAction(
  "FETCH_BACKTEST_META_REQUEST",
  "FETCH_BACKTEST_META_SUCCESS",
  "FETCH_BACKTEST_META_FAILURE"
)<void, T.Meta, void>();

export const fetchBacktestResult = createAsyncAction(
  "FETCH_BACKTEST_RESULT_REQUEST",
  "FETCH_BACKTEST_RESULT_SUCCESS",
  "FETCH_BACKTEST_RESULT_FAILURE"
)<{ setup: T.Setup; taskId: string }, T.Result, void>();
